import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { useI18n } from 'vue-i18n'
import { reactive, ref, computed } from 'vue'
import { businessList, downloadGet, deleteExport } from '@/api/yuntuSales/exportCenter'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
import getAppidType from './hooks/getAppIdType'
import getOption from './hooks/getOptions'
import { DcMessage } from '@dc-platform/dc-components'
import vIfAndPermission from '@/utils/ifAndPermission'

const __default__ = { name: 'list' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()

// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BigScoreBakcData) => void }>()
const { appIdData } = getAppidType()
const selectEXportEnum = computed(() => getOption(appIdData))
const tableRef = ref()
const queryForm = reactive({
  taskType: undefined,
  startTime: '',
  endTime: ''
})
const tableEXportEnum = computed(() => getOption())

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await businessList({ ...params, appId: appIdData.includes('cos_zbu') ? 'cos_zbu' : appIdData })
  callBack(res)
}
const differentAppidDelete = () => {
  const appIds = {
    cos_zbu_fbu: 'fbu_marketing_export_del_btn',
    cos_zbu_lbu: 'lbu_marketing_export_del_btn',
    cos_lbu: 'lbu_exportcenter_delete_btn',
    cos_fbu: 'fbu_exportcenter_delete_btn',
    cos_ofbu: 'ofbu_exportcenter_delete_btn'
  }
  return appIds[appIdData]
}
const differentAppidDownload = () => {
  const appIds = {
    cos_zbu_fbu: 'fbu_marketing_export_down_btn',
    cos_zbu_lbu: 'lbu_marketing_export_down_btn',
    cos_lbu: 'lbu_exportcenter_download_btn',
    cos_fbu: 'fbu_exportcenter_download_btn',
    cos_ofbu: 'ofbu_exportcenter_download_btn'
  }
  return appIds[appIdData]
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: t('operate.82pppq'), dataIndex: 'fileName', minWidth: 250 },
  { title: t('operate.ta0eas'), dataIndex: 'taskType', minWidth: 190, dicData: tableEXportEnum.value },
  {
    title: t('operate.lbczwf'),
    dataIndex: 'taskStatus',
    minWidth: 150,
    format: (text: number) => {
      return [
        t('operate.ib0ffr'),
        t('operate.vw3d2n'),
        t('operate.0lkk5n'),
        t('operate.jz7ejl'),
        t('operate.eicn8l'),
        t('operate.iq7ql8')
      ][text]
    }
  },
  { title: t('common.createTime'), dataIndex: 'createTime', minWidth: 190 },
  { title: t('operate.tltno5'), dataIndex: 'updateTime', minWidth: 190 },
  { title: t('operate.m9u0pr'), dataIndex: 'createByName' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = async (_row?: BigScoreBakcData) => {
  try {
    const res = await downloadGet({ id: _row?.id })
    location.href = res.data.url
    DcMessage.success(t('operate.azs0kk'))
  } catch (error) {
    console.log('error: ', error)
  }
}
const deleteRow = (row: any) => {
  Modal.delete({
    name: row.fileName,
    onOk() {
      deleteExport({ id: row.id }).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosExportCenter"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "taskType",
                    label: _unref(t)('operate.ta0eas')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.taskType,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.taskType) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectEXportEnum.value, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.value,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.lang ? _unref(t)(item.lang) : item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "startTime",
                    label: _unref(t)('common.createTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === '$taskType')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text || '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'taskStatus')
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString([
                  _unref(t)('operate.ib0ffr'),
                  _unref(t)('operate.vw3d2n'),
                  _unref(t)('operate.0lkk5n'),
                  _unref(t)('operate.jz7ejl'),
                  _unref(t)('operate.eicn8l'),
                  _unref(t)('operate.iq7ql8')
                ][record.taskStatus] || '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 2 }, {
                    default: _withCtx(() => [
                      (_unref(vIfAndPermission)(differentAppidDownload(), record.taskStatus === 1))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            onClick: ($event: any) => (addEdit(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.download')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, differentAppidDelete()]
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})